import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AlertService } from 'src/app/components/_alert/alert.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { Location } from '@angular/common';
import { AdministracionCarteraApiService } from '../services/administracion-cartera-api.service';
import { Bag } from '../models/bag';
import { Router } from '@angular/router';
import { ESystemAccess, ESystemProfileList } from 'src/app/enum/EAccess';

@Component({
    selector: 'app-admin-cartera-create',
    templateUrl: './admin-cartera-create.component.html',
    styleUrls: ['./admin-cartera-create.component.scss']
})
export class AdminCarteraCreateComponent {
    private readonly access: string[] = [
        ESystemAccess.ADMINISTRACION_CARTERA,
        ESystemProfileList.WEB
    ];

    private hasUserAccess = true;

    private MAX_FILE_SIZE = 1000000 as const;

    public newBagForm!: FormGroup;
    public fileName = '';

    public nameControl: FormControl = new FormControl('')

    public formLoading = false;

    constructor(
        private _sessionService: SessionService,
        private formBuilder: FormBuilder,
        private alertsService: AlertService,
        private _apiService: AdministracionCarteraApiService,
        private location: Location,
        public dialog: MatDialog,
        private _router: Router,
        private _session: SessionService,
    ) { }

    ngOnInit(): void {
        if (!this.checkAccess()) {
            this._router.navigate(['/request-access'])
            return;
        };

        this.newBagForm = this.formBuilder.group({
            name: [''],
            file: ['']
        })
    }

    checkAccess() {
        const hasAdminCarteraPermission = this._session.getUserAccess().includes(this.access[0]);
        const hasWebProfile = this._session.getUserProfileList().includes(this.access[1]);

        return hasAdminCarteraPermission && hasWebProfile;
    }

    handleUpload(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];

        if (!file) return;

        if (file.size > this.MAX_FILE_SIZE) {
            this.alertsService.error('El tamaño del archivo no puede ser mayor a 1 MB.');
            return;
        }

        this.fileName = file.name;

        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = () => {
            const file = reader?.result?.toString().split(',')[1];
            const fileControl = this.newBagForm.get('file');

            fileControl?.setValue(file);
        };
    }

    submitArchivo() {
        this.formLoading = true;
        const fileControl = this.newBagForm.get('file');
        const nameControl = this.newBagForm.get('name');

        if (typeof (fileControl?.value) !== 'string' || !fileControl?.value?.length) {
            this.alertsService.error('Debe cargar un archivo para crear la cartera.');
            this.formLoading = false;
            return;
        }

        const idOrganizacion = this._sessionService.getOrganization();
        const idUsuario = this._sessionService.getUserInfo().username;

        let name = nameControl?.value;
        if (name == '') {
            name = 'Cartera ' + idOrganizacion + ' ' + new Date().getTime()
        }

        const bag: Bag = {
            name: name,
            description: idOrganizacion + ' ' + idUsuario,
            base64Content: fileControl?.value
        }

        this._apiService.createBag(bag).subscribe(
            (res) => {
                if (!res.bagId) {
                    this.alertsService.error("Ocurrió un error al intentar crear la cartera.")
                } else {
                    this._router.navigate(['/administracion-cartera-detalle', res.bagId])
                }
                
                this.formLoading = false
            },
            ({error}) => {
                this.alertsService.error(error?.message || "Ocurrió un error al intentar crear la nueva cartera.")
                this.formLoading = false
            }
        )
    }

    goBack() {
        this.location.back();
    }
}
